import c from "../common"

export default {
    // Dashboard
    Edit: "Edit",
    Description: "Description",
    VoucherDiscount: c.voucher.en.uppercase + " & " + c.discount.en.uppercase,
    ParVendor: "Participating Vendors",
    Overview: "Overview",
    VendorList: "Vendor List",
    Remove: "Remove",
    ConfirmRemove: "Confirm remove?",

    // Common
    Event: c.event.en,    
    Confirm: c.Confirm.en,
    Cancel: c.cancel.en,
    Next: c.next.en,
    Previous: c.previous.en,
    NA: c.NA.en,

    // Status
    Pending: c.Pending.en,
    OnGoing: c.OnGoing.en,
    Expired: c.Expired.en,
    Cancelled: c.Cancelled.en,  
    Participated: "Participated",
    WaitApprove: c.WaitApprove.en,
    Rejected: c.Rejected.en,
    Approved: c.Approved.en,

    // Message
    Warning1: "Please fill in the name",
    Warning2_1: "Description cannot be more than ",
    Warning2_2: " Words",
    Warning3: "Please fill in the date",
    Warning4: "Due to the overlapping of the event date and the current Estamp plan date, no Estamp plan can be created for this event:",
    Warning5: "Please provide an available day range",
    Warning6: "Corresponding voucher and Estamp plan (if exist) will be cancelled",
    Warning7: "Corresponding Estamp plan (if exist) will be cancelled",
    Info1: "The available starting date is limited to 2 days after current date. The End date has no limitation",
    Success1: "Invite sent! Please refresh the page",
    Success2: "Event cancelled! Please refresh the page",
    Success3: "Event and Estamp Plan cancelled! Please refresh the page",
    Success4: "Success! Please refresh the page",
    Success5: "Event modified! Please refresh the page",
    Success6: "Event modified and related Estamp plan cancelled! Please refresh the page",

    // Step 1
    CreateEvent: "Create New " + c.event.en,
    Name: "Name",
    Date: "Date",

    // Step 2
    InviteVendor: "Invite partners to join the event",
    ModifyList: c.ModifyPartnersList.en,
    SelectAll: "Select All",
    SendInvite: "Send Invitation",

    // Step 3
    Success: "Event created. Please refresh the page",
    ToVoucher: "Create Voucher",
    Skip: "Skip for now",

    // Edit
    Back: c.Back.en,
    EditEvent: "Edit " + c.event.en,
    Submit: "Submit",
}